import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgRedeem = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.48817 0.807004L10.5747 5.2546L15.5255 5.82932C15.981 5.8821 16.1637 6.43511 15.827 6.74124L12.1656 10.0646L13.1393 14.8676C13.2289 15.3098 12.7501 15.6511 12.3495 15.4312L8.00043 13.0373L3.65134 15.4312C3.25135 15.6517 2.77197 15.3098 2.86151 14.8676L3.83521 10.0646L0.173256 6.74124C-0.163448 6.4357 0.0192319 5.8821 0.474737 5.82932L5.4256 5.2546L7.51209 0.807004C7.70432 0.397665 8.29594 0.397665 8.48817 0.807004Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgRedeem)
const IconSvgRedeem = createIcon(ForwardRef, 'SvgRedeem')
export default IconSvgRedeem
